import { render } from "./SnippetsPanel.vue?vue&type=template&id=677cd57b&scoped=true&ts=true"
import script from "./SnippetsPanel.vue?vue&type=script&lang=ts"
export * from "./SnippetsPanel.vue?vue&type=script&lang=ts"

import "./SnippetsPanel.vue?vue&type=style&index=0&id=677cd57b&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677cd57b"]])

export default __exports__